import { render } from "./StandardLogo.vue?vue&type=template&id=13b40463&ts=true"
import script from "./StandardLogo.vue?vue&type=script&lang=ts"
export * from "./StandardLogo.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__